if (typeof Promise === 'undefined') {
  window.Promise = require('promise/lib/es6-extensions.js');
}

require('element-closest/element-closest.js');
